






















































































import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

/* eslint-disable */
import { User } from '@/models/User'
import { DateTime } from 'luxon'
/* eslint-enable */

export default Vue.extend({
  data() {
    return {
      loading: false as boolean,
      editUserDialog: false as boolean,
      selectedUser: null as User,
      users: [] as User[],
      headers: [
        {
          text: 'Name',
          align: 'start',
          sortable: false,
          value: 'firstName'
        },
        {
          text: 'Email',
          sortable: false,
          value: 'email'
        },
        {
          text: 'Registered Date',
          sortable: false,
          value: 'createdAt'
        },
      ],
      form: {
        id: 0,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: ''
      },
      snackbarText: '',
      snackbar: false,
    }
  },
  computed: {
    ...mapGetters({
      currentDealerId: 'dealers/currentDealerId'
    }),
    obs () : any {
      return this.$refs.observer as any
    }
  },
  methods: {
    ...mapActions({
      updateUserAsAdmin: 'auth/updateUserAsAdmin'
    }),
    cancel() : void {
      this.editUserDialog = false
    },
    async getUsers() : Promise<void> {
      const userArray = await User.getUsersByDealer(this.currentDealerId, '')
      this.users = userArray.filter(function (user: User) {
        let check = false
        user.roles.forEach((role: any) => {
          if ([2].includes(role.id)) { check = true }
        })
        return check
      })
    },
    parseDateTime(time: string) : string {
      const date = DateTime.fromISO(time)
      return date.toLocaleString({ month: 'long', day: 'numeric' }) + ', ' + date.year
    },
    editItem(item: User) {
      this.selectedUser = item
      this.editUserDialog = true
      this.form.id = this.selectedUser.id
      this.form.firstName = this.selectedUser.firstName
      this.form.lastName = this.selectedUser.lastName
      this.form.phoneNumber = this.selectedUser.phoneNumber
      this.form.email = this.selectedUser.email
    },
    async updateUser() {
      this.loading = true
      const isValid = await this.obs.validate()
      if (isValid) {
          const response = await this.updateUserAsAdmin(this.form)
          if (response === 200) {
            this.snackbarText = 'Account information has been successfully updated.'
            this.snackbar = true
            this.editUserDialog = false
            this.getUsers()
            this.loading = false
          } else {
            this.loading = false
            this.snackbarText = 'There was an error while updating the account.'
            this.snackbar = true
          }
      } else {
        this.loading = false
        this.$vuetify.goTo(".error--text")
      }
    },
  },
  async mounted() {
    this.getUsers()
  },
  components: {},
})
